import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Guitar, Radio, ListMusic, Shield } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useAdmin } from '../context/AdminContext';

const BASE_TABS = [
  { label: 'Home',  Icon: Home,      href: '/dashboard'          },
  { label: 'Gigs',  Icon: Guitar,    href: '/dashboard/gigs'     },
  { label: 'Live',  Icon: Radio,     href: '/dashboard/requests' },
  { label: 'Songs', Icon: ListMusic, href: '/dashboard/songs'    },
];

export default function BottomNav() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();

  const TABS = isAdmin
    ? [...BASE_TABS, { label: 'Admin', Icon: Shield, href: '/admin' }]
    : BASE_TABS;

  const activeTab =
    location.pathname.startsWith('/dashboard/requests') ? 'Live'  :
    location.pathname.startsWith('/dashboard/songs')    ? 'Songs' :
    location.pathname.startsWith('/dashboard/gigs')     ? 'Gigs'  :
    location.pathname.startsWith('/admin')              ? 'Admin' :
    'Home';

  return (
    <div style={{
      flexShrink: 0,
      display: 'flex',
      background: theme.surface,
      borderTop: `1px solid ${theme.border}`,
      paddingBottom: 'env(safe-area-inset-bottom)',
      boxShadow: theme.isDark
        ? '0 -1px 0 rgba(255,255,255,0.06)'
        : '0 -2px 12px rgba(0,0,0,0.08)',
    }}>
      {TABS.map(({ label, Icon, href }) => {
        const active = activeTab === label;
        return (
          <button
            key={label}
            onClick={() => navigate(href)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              padding: '10px 0',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: active ? theme.primary : theme.textMuted,
              WebkitTapHighlightColor: 'transparent',
              minHeight: 56,
              transition: 'color 0.15s',
            }}
          >
            <Icon size={22} strokeWidth={active ? 2.5 : 1.8} />
            <span style={{
              fontSize: 10,
              fontWeight: active ? 700 : 400,
              letterSpacing: 0.2,
            }}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
